export function monitorCallButtonReadyState(): void {
  // this function checks the ready state of the document
  // if ready state is not complete we want to hide the
  // home page call button so to avoid gliches in delayed styles
  const docStates = {
    stateComplete: 'complete',
    stateLoading: 'loading',
    stateInteractive: 'interactive',
  };
  const checkState = () => {
    // this will run only if -enable-jsstate-check class is selected
    const callButton = document.querySelector('.-enable-jsstate-check');
    if (
      document.readyState === docStates.stateLoading ||
      document.readyState === docStates.stateInteractive
    ) {
      callButton?.classList.add('hide');
    }

    if (document.readyState === docStates.stateComplete) {
      callButton?.classList.remove('hide');
      document.removeEventListener('readystatechange', checkState);
    }
  };
  checkState();
  document.addEventListener('readystatechange', checkState);
}

monitorCallButtonReadyState();
